module.exports = __webpack_public_path__ + "img/subscription.eea86903.svg";